import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './ui/component/home';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MyLoader from './ui/elements/loader/loader';
import AlertMessage from './ui/elements/alert/index';
import './App.css';

function App() {
  const loading = useSelector((state) => state.spinner.loading);
  const alertMessage = useSelector((state) => state.alert.alertMessage);

  const [content, setContent] = useState();


  useEffect(() => {
    let loader = "";
    if (loading) {
      loader = <MyLoader />
    }

    let content = "";
    if (alertMessage && alertMessage.success === false) {
      content = <AlertMessage alertMessage={alertMessage} />
    } else {
      content = <div className="App">
        <Router>
          <Routes>
            <Route element={<Home />} exact path="/:key?" />
          </Routes>
        </Router>
        {loader}
      </div>
    }

    setContent(content);

  }, [loading, alertMessage]);


  return (
    <div>{content}</div>
  )
}

export default App;
